(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SFMLWeb", [], factory);
	else if(typeof exports === 'object')
		exports["SFMLWeb"] = factory();
	else
		root["SFMLWeb"] = factory();
})(window, function() {
return 


// WEBPACK FOOTER //
// webpack://SFMLWeb/webpack/universalModuleDefinition